import { getBasicContentSchema } from '@/lib/zy-tiptap-utils';
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ZyStudioInstructionNodeView } from './zystudio-instruction-node-view';
import ZyStudioNodeView from './zystudio-node-view';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyStudio: {
            insertZyStudio: (options?: { caption?: string; guid?: string; instructions?: string; activityType?: string }) => ReturnType;
        };
    }
}

export const ZyStudioNodeHeadless = Node.create({
    name: 'zyStudio',

    content: 'zyStudioInstruction',

    group: 'block',

    draggable: true,

    isolating: true,

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => {
                    return element.getAttribute('id');
                },
                renderHTML: attributes => {
                    if (!attributes.id) {
                        return {};
                    }
                    return { id: attributes.id };
                },
            },
            caption: {
                default: '',
                parseHTML: element => {
                    return element.getAttribute('caption') || '';
                },
                renderHTML: attributes => {
                    if (!attributes.caption) {
                        return {};
                    }
                    return { caption: attributes.caption };
                },
            },
            guid: {
                default: null,
                parseHTML: element => {
                    return element.getAttribute('guid');
                },
                renderHTML: attributes => {
                    if (!attributes.guid) {
                        return {};
                    }
                    return { guid: attributes.guid };
                },
            },
            activityType: {
                default: 'tinker',
                parseHTML: element => {
                    return element.getAttribute('activity_type') || 'tinker';
                },
                renderHTML: attributes => {
                    if (!attributes.activityType) {
                        return {};
                    }
                    return { activity_type: attributes.activityType };
                },
            },
            isLabEditMode: {
                default: false,
                rendered: false,
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'zyStudio',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['zyStudio', HTMLAttributes, 0];
    },

    addCommands() {
        return {
            insertZyStudio:
                (options = {}) =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: 'zyStudio',
                        attrs: {
                            caption: options.caption,
                            guid: options.guid,
                            activityType: options.activityType || 'tinker',
                        },
                        content: [
                            {
                                type: 'zyStudioInstruction',
                                content: [
                                    {
                                        type: 'paragraph',
                                    },
                                ],
                            },
                        ],
                    });
                },
        };
    },
});

export const ZyStudioInstructionNodeHeadless = Node.create({
    name: 'zyStudioInstruction',

    content: function () {
        return getBasicContentSchema();
    },

    group: 'block',

    defining: true,

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => {
                    return element.getAttribute('id');
                },
                renderHTML: attributes => {
                    if (!attributes.id) {
                        return {};
                    }
                    return { id: attributes.id };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'zyStudioInstruction',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['zyStudioInstruction', HTMLAttributes, 0];
    },
});

export const ZyStudioInstructionNode = ZyStudioInstructionNodeHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyStudioInstructionNodeView);
    },
});

export const ZyStudioNode = ZyStudioNodeHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyStudioNodeView);
    },
});
